export const ModalLayers = {
  defaultOverlay:8888,
  defaultContent:9009,
  surveyDrawer:9999,
  nestedOverlay:1000001,
  interactivePortal:1000002,
  nestedContent:9000009
};

export const interactivePortalStyle = {
  zIndex:ModalLayers.interactivePortal,
  pointerEvents:'auto'
};
